module.exports = __webpack_public_path__ + "static/outsourcing-8411659df05c2048bf8a5a827e8176c8.svg";